'use strict';

export default class CallbackForm {
    constructor() {
        this.bindHandlers();
        this.inputName = $('#call_back_name');
        this.inputEmail = $('#call_back_email');
        this.inputPhone = $('#call_back_phone');
        this.inputMessage = $('#call_back_message');

        this.errorNameField = $('#call_back_name_error');
        this.errorEmailField = $('#call_back_email_error');
        this.errorPhoneField = $('#call_back_phone_error');
        this.errorMessageField = $('#call_back_message_error');
    }

    bindHandlers() {
        let _self = this;

        $('#callback-form').submit(function (e) {
            e.preventDefault();

            _self.errorNameField.text('').hide();
            _self.errorEmailField.text('').hide();
            _self.errorPhoneField.text('').hide();
            _self.errorMessageField.text('').hide();

            const url = $(this).attr('action');

            $.ajax({
                type: "POST",
                url: url,
                data: new FormData(this),
                processData: false,
                contentType: false,
                success: data => {
                    if (data.success) {
                        $('#callBackForm').foundation('close');

                        $('#finalModal').foundation('open');

                        _self.inputName.removeClass('form-error').val('');
                        _self.inputEmail.removeClass('form-error').val('');
                        _self.inputPhone.removeClass('form-error').val('');
                        _self.inputMessage.removeClass('form-error').val('');

                        _self.errorNameField.text('').hide();
                        _self.errorEmailField.text('').hide();
                        _self.errorPhoneField.text('').hide();
                        _self.errorMessageField.text('').hide();
                    } else {
                        $.each(data.errors.errors.children, function (k, v) {
                            if (v.errors !== undefined) {
                                $('#call_back_' + k +'_error').text(v.errors[0]).show();
                                // var field = $('[name="call_back[' + k + ']"]');
                                // field.parent('form-control').find('form-error').text().show();
                            }
                        })
                    }
                }
            })
        })
    }
}
